import { render, staticRenderFns } from "./Invoiceinformation.vue?vue&type=template&id=bd20e586&scoped=true"
import script from "./Invoiceinformation.vue?vue&type=script&lang=js"
export * from "./Invoiceinformation.vue?vue&type=script&lang=js"
import style0 from "./Invoiceinformation.vue?vue&type=style&index=0&id=bd20e586&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd20e586",
  null
  
)

export default component.exports